import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaInstagram, FaFacebook, FaYoutube, FaSpotify } from 'react-icons/fa';
import { FiMenu } from 'react-icons/fi';
import logo from '../styles/images/logoAlaiak.png';
import '../styles/MobileHeader.css';

const MobileHeader = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <header className="mobile-header">
            <div className="mobile-header-top">
                <NavLink to="/" className="mobile-logo-link">
                    <img src={logo} alt="Alaiak Logo" className="mobile-logo" style={{ width: 55, height: 55 }} />
                </NavLink>
                <span className="mobile-title">ALAIAK</span>
                <button className="mobile-menu-btn" style={{ padding: '12px' }} onClick={() => setMenuOpen(!menuOpen)}>
                    <FiMenu size={36} />
                </button>
            </div>
            {menuOpen && (
                <nav className="mobile-nav-panel">
                    <NavLink to="/" end className={({ isActive }) => isActive ? "active" : ""} onClick={() => setMenuOpen(false)}>Hasiera</NavLink>
                    <NavLink to="/bio" className={({ isActive }) => isActive ? "active" : ""} onClick={() => setMenuOpen(false)}>Taldea</NavLink>
                    <NavLink to="/events" className={({ isActive }) => isActive ? "active" : ""} onClick={() => setMenuOpen(false)}>Ekitaldiak</NavLink>
                    <NavLink to="/videos" className={({ isActive }) => isActive ? "active" : ""} onClick={() => setMenuOpen(false)}>Bideoak</NavLink>
                    <NavLink to="/contact" className={({ isActive }) => isActive ? "active contact-link" : "contact-link"} onClick={() => setMenuOpen(false)}>Kontaktua</NavLink>
                    <div className="mobile-social-networks">
                        <a href="https://instagram.com/alaiaksoinulariak"><FaInstagram /></a>
                        <a href="https://www.facebook.com/profile.php?id=61554244191446&ref=_ig_profile_ac"><FaFacebook /></a>
                        <a href="https://www.youtube.com/@AlaiakSoinulariak"><FaYoutube /></a>
                        <a href="https://spotify.com"><FaSpotify /></a>
                    </div>
                </nav>
            )}
        </header>
    );
};

export default MobileHeader;
